<template>

  <div id="content" class="sections">

    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ changeMetatagHtml($t("starterKits.metaTitle")) }}</title>

      <link rel="canonical" href="https://komatools.com/es/kits-inicio-one-for-all"/>
      <link rel="alternate" href="https://komatools.com/es/kits-inicio-one-for-all" hreflang="es"/>
      <link rel="alternate" href="https://komatools.com/en/starter-kits-one-for-all" hreflang="en"/>
      <link rel="alternate" href="https://komatools.com/fr/kits-de-demarrage-one-for-all" hreflang="fr"/>
      <link rel="alternate" href="https://komatools.com/es/kits-inicio-one-for-all" hreflang="x-default"/>

      <meta name="title" :content="changeMetatagHtml($t('starterKits.metaTitle'))">

      <meta name="description" :content="$t('starterKits.metaDescription')">

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" content="https://komatools.com/">
      <meta property="og:title" :content="changeMetatagHtml($t('starterKits.metaTitle'))">
      <meta property="og:description" :content="$t('starterKits.metaDescription')">
      <meta property="og:image" content="https://komatools.com/img/komatoolsSocial.jpg">

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" content="https://komatools.com/">
      <meta property="twitter:title" :content="changeMetatagHtml($t('starterKits.metaTitle'))">
      <meta property="twitter:description" :content="$t('starterKits.metaDescription')">
      <meta property="twitter:image" content="https://komatools.com/img/komatoolsSocial.jpg">
    </Head>

    <div class="section light paddingBigger">
      <div>

        <div class="banner centered">
          <div class="header">
            <h1 class="title">{{ $t("starterKits.title") }}</h1>
            <h2 v-html="$t('starterKits.subTitle')" class="subTitle"></h2>
          </div>
        </div>

        <details>
          <summary v-html="$t('starterKits.summary.title')"></summary>
          <p v-html="$t('starterKits.summary.descriptionParagraph1')"></p>
          <p v-html="$t('starterKits.summary.descriptionParagraph2')"></p>
          <p v-html="$t('starterKits.summary.descriptionParagraph3')"></p>
          <p v-html="$t('starterKits.summary.descriptionParagraph4')"></p>
          <p v-html="$t('starterKits.summary.descriptionParagraph5')"></p>
        </details>

        <div class="options buttons wrap centered">
          <a class="button accent" v-for="(filter, index) in filtersRef" :key="index">
            <span
                @click="filterData(filter)"
                :class="{ active: JSON.stringify(activeFilter) === JSON.stringify(filter.code) }"
            >
              {{ $t(filter.text) }}
            </span>
          </a>
        </div>

        <div class="banner centered" v-if="error">
          <p v-html="$t(error)"></p>
        </div>
        <div v-else>
          <ArticlesList :articles="articles"/>
        </div>

      </div>
    </div>

  </div>


</template>


<script>
import {ref, onMounted} from "vue";
import {useRoute} from "vue-router";
import getArticles from "../../composables/getArticles";
import GENERIC_VARIABLES from "../../../config";
import ArticlesList from "@/components/ArticlesList.vue";
import {Head} from "@vueuse/head";

export default {
  name: "ProTools",
  components: {ArticlesList, Head},

  setup() {
    const route = useRoute();

    const subcategories = [];
    const articles = ref([]);
    const error = ref(null);
    let loader = null;

    const filtersRef = ref([
      {text: "filtersArticles.all.text", code: ["kit:si"], query: null},
      {text: "filtersArticles.starterKits12v.text", code: ["kit:si", "voltaje:12"], query: "12v"},
      {text: "filtersArticles.starterKits20v.text", code: ["kit:si", "voltaje:20"], query: "20v"},
    ]);

    const activeFilter = ref(filtersRef.value[0].code);

    const setupArticles = (filters) => {
      const result = getArticles(GENERIC_VARIABLES.PRODUCT_BRAND, subcategories, filters);
      loader = result.load;

      loader().then(() => {
        articles.value = result.articles.value;
        error.value = result.error.value;
      });
    };

    const filterData = (filter) => {
      activeFilter.value = filter.code;
      setupArticles(filter.code);
    };

    onMounted(() => {
      const queryFilter = route.query.filter;

      if (queryFilter) {
        const matched = filtersRef.value.find(f => f.query === queryFilter.toLowerCase());

        if (matched) {
          activeFilter.value = matched.code;
          setupArticles(matched.code);

          return;
        }
      }

      setupArticles(activeFilter.value);
    });

    const changeMetatagHtml = (html) => {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    };

    return {
      articles,
      filtersRef,
      activeFilter,
      filterData,
      error,
      GENERIC_VARIABLES,
      changeMetatagHtml,
    };
  },
};
</script>
